/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProvisioningNotificationStatusEnum = 'SUCCESS' | 'PENDING' | 'FAILED';

export const ProvisioningNotificationStatusEnum = {

    SUCCESS: 'SUCCESS' as ProvisioningNotificationStatusEnum,

    PENDING: 'PENDING' as ProvisioningNotificationStatusEnum,

    FAILED: 'FAILED' as ProvisioningNotificationStatusEnum
};

